// extracted by mini-css-extract-plugin
export default {"container":"_share-modal_container__iHqbO","share_item":"_share-modal_share_item__XDYss","share_story":"_share-modal_share_story__VeQJ-"};